import { createContext, useState } from "react";
import api from "./api";

const ProductContext = createContext();

const ProductProvider = ({ children }) => {
  const [id, setId] = useState(window.location.pathname.replace("/", ""));
  const [companyId, setCompanyId] = useState();

  const [productVariantOptions, setProductVariantOptions] = useState([]);
  const [productVariantProducts, setProductVariantProducts] = useState([]);

  const [productCombines, setProductCombines] = useState([]);
  const [productPartGroups, setProductPartGroups] = useState([]);
  const [productMaterialGroups, setProductMaterialGroups] = useState([]);
  const [productParts, setProductParts] = useState([]);

  const [productMaterials, setProductMaterials] = useState([]);

  const getProductVariantOptions = async (force) => {
    if (productVariantOptions.length > 0 && !force)
      return productVariantOptions;

    if (!id) return [];
    const response = await api.getProductVariantOptions(id);
    setProductVariantOptions(response.data);

    return response.data;
  };

  const getProductVariantProducts = async (force) => {
    if (productVariantProducts.length > 0 && !force)
      return productVariantProducts;

    if (!id) return [];
    const response = await api.getProductVariantProducts(id);
    setProductVariantProducts(response.data);

    return response.data;
  };

  const getProductPartGroups = async (force) => {
    if (productPartGroups.length > 0 && !force) return productPartGroups;

    if (!id) return [];
    const response = await api.getProductPartGroups(id);
    setProductPartGroups(response.data);

    return response.data;
  };

  const getProductMaterials = async (force) => {
    if (productMaterials.length > 0 && !force) return productMaterials;

    if (!id) return [];
    const response = await api.getProductMaterials(id);
    setProductMaterials(response.data);

    return response.data;
  };

  const getProductParts = async (force) => {
    if (productParts.length > 0 && !force) return productParts;

    if (!id) return [];
    const response = await api.getProductParts(id);
    setProductParts(response.data);

    return response.data;
  };

  const getProductCombines = async (force) => {
    if (productCombines.length > 0 && !force) return productCombines;

    if (!id) return [];
    const response = await api.getProductCombines(id);
    setProductCombines(response.data);

    return response.data;
  };

  const getProductMaterialGroups = async (force) => {
    if (productMaterialGroups.length > 0 && !force)
      return productMaterialGroups;

    if (!id) return [];
    const response = await api.getProductMaterialGroups(id);
    setProductMaterialGroups(response.data);

    return response.data;
  };

  const saveProduct = async (productInfo) => {
    const response = await api.saveProduct(productInfo);

    return response.data;
  };

  const values = {
    id,
    companyId,
    setCompanyId,
    getProductVariantOptions,
    getProductVariantProducts,
    getProductCombines,
    getProductPartGroups,
    getProductParts,
    getProductMaterials,
    getProductMaterialGroups,
    saveProduct,
  };

  return (
    <ProductContext.Provider value={values}>{children}</ProductContext.Provider>
  );
};

export { ProductContext, ProductProvider };
